const formInputTags = ['omk-checkbox', 'omk-radio', 'omk-slider', 'omk-text-field', 'omk-date-picker', 'omk-select'] as const;
export type FormInputComponentTag = (typeof formInputTags)[number];

export interface ComponentOptions {
  /** Toggle navigation behaviour when following links.
   * When `false`, links will behave as normal.
   * When `true`, following a link within the current tab emits an `omkNavigate` event
   * that you can catch and handle to integrate a SPA router and avoid unnecessary full page loads. */
  interceptNavigation?: boolean;
  /** Override the built-in contraint validation messages driven by ValidityState of form-aware inputs. By default, these are localized according to OS region by the browser. */
  componentValidationMessageOverrides?: {
    [key in (typeof formInputTags)[number]]?: ValidationMessageOverride | ValidationMessageOverride[];
  };
}

export interface ComponentFilter {
  type?: string;
}

export interface ValidationMessageOverride {
  badInput?: string;
  patternMismatch?: string;
  rangeOverflow?: string;
  rangeUnderflow?: string;
  stepMismatch?: string;
  tooLong?: string;
  tooShort?: string;
  typeMismatch?: string;
  valueMissing?: string;
  /** set if a component has more than one set of overrides to choose between */
  componentFilter?: ComponentFilter;
}

export const libraryComponentOptions: ComponentOptions = {
  interceptNavigation: false,
  componentValidationMessageOverrides: {},
};

/** Set options that affect behaviour for all components */
export const setOptions = (options: ComponentOptions) => {
  if (Object.prototype.hasOwnProperty.call(options, 'interceptNavigation')) {
    libraryComponentOptions.interceptNavigation = options.interceptNavigation;
  }
  if (Object.prototype.hasOwnProperty.call(options, 'componentValidationMessageOverrides')) {
    /* eslint guard-for-in: off */
    // These are warnings about bad formats at runtime. If we filtered first we might miss them.
    for (const tagName in options.componentValidationMessageOverrides) {
      if (!(tagName as FormInputComponentTag)) {
        console.warn('Unrecognized form input tag in componentValidationMessageOverrides:', tagName);
      }
      for (const messageType in options.componentValidationMessageOverrides[tagName]) {
        if (!(messageType as keyof ValidationMessageOverride)) {
          console.warn(`Unrecognized validation message type in override for ${tagName} tag: ${messageType}`);
        }
      }
    }
    libraryComponentOptions.componentValidationMessageOverrides = options.componentValidationMessageOverrides;
  }
};
